import createEvent from '@/scripts/utils/create-event';
import ParticlesPreloader from '@/scripts/elements/ParticlesPreloader';
import { DOCUMENT_ELEMENT } from '@/scripts/constants';
import toggleBodyScroll from '@/scripts/utils/toggle-body-scroll';
import { TweenLite, TimelineMax } from 'gsap/TweenMax';
import isIe from '@/scripts/utils/detect-ie';
import './Preloader.scss';

const defaults = {
  element: null,
  images: '[data-role="preloader-images"]',
  text: '[data-role="preloader-text"]',
  start: '[data-role="preloader-start"]',
  particles: '[data-role="preloader-particles"]',
  activeClass: 'has-preloader',
  startClass: 'preloader-start',
  hiddenClass: 'is-hidden',
  startTimeout: 500,
};

export default class Preloader {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.element = options.element;
    if (!this.element) return;
    this.start = this.element.querySelector(options.start);
    this.particlesElement = this.element.querySelector(options.particles);
    this.particles = null;

    if (this.particlesElement && !isIe()) {
      this.particles = new ParticlesPreloader({
        element: this.particlesElement,
        initCallback: () => {
          this.element.classList.add('is-loaded');
        },
      });
    }
    this.activeClass = options.activeClass;
    this.startClass = options.startClass;
    this.hiddenClass = options.hiddenClass;
    this.startTimeout = options.startTimeout;
  }

  async play() {
    if (this.particles) {
      setTimeout(() => {
        this.element.classList.add('no-bg');
        this.particles.playPreloader(() => {
          this.removePreloader();
        });
      }, this.startTimeout * 3);
    } else {
      setTimeout(() => {
        this.removePreloader();
      }, this.startTimeout);
    }
  }

  static startLoading() {
    console.log('Loading'); // eslint-disable-line no-console
    toggleBodyScroll(true, null);
    TweenLite.set('[data-main-animation]', { autoAlpha: 0, pointerEvents: 'none' });
  }

  removePreloader() {
    const tl = new TimelineMax();

    setTimeout(() => {
      DOCUMENT_ELEMENT.classList.remove(this.activeClass);
      DOCUMENT_ELEMENT.dispatchEvent(createEvent('preloaderEnd'));
      requestIdleCallback(() => {
        TweenLite.to(this.element, 1, {
          autoAlpha: 0,
          onComplete: () => {
            console.log('Loading finished. Enjoy!'); // eslint-disable-line no-console
            toggleBodyScroll(false, null);
            if (this.particles) {
              this.particles.destroy();
            }
            // this.element.remove();
            tl
              .staggerFromTo('[data-main-animation="fade-in-down"]', 1, { y: -50 }, {
                y: 0,
                autoAlpha: 1,
                clearProps: 'all',
              }, 0.2)
              .staggerFromTo('[data-main-animation="fade-in-left"]', 1, { x: 50 }, {
                x: 0,
                autoAlpha: 1,
                clearProps: 'all',
              }, 0.2, 0)
              .staggerFromTo(Array.from(document.querySelectorAll('[data-main-animation="fade-in-right"]')).reverse(), 1, { x: -50 }, {
                x: 0,
                autoAlpha: 1,
                clearProps: 'all',
              }, 0.2, 0)
              .to('[data-main-animation="fade-in"]', 1, { clearProps: 'opacity, visibility, pointer-events' }, 0.2)
              .staggerFromTo('[data-main-animation="fade-in-up"]', 1, { y: 100 }, {
                y: 0,
                autoAlpha: 1,
                clearProps: 'all',
              }, 0.2, 0);
          },
        });
      }, { timeout: 1000 });
    }, this.startTimeout);
  }
}



// WEBPACK FOOTER //
// ./scripts/elements/Preloader/Preloader.js